import PropTypes from 'prop-types';
import { Row, Col } from "reactstrap";
import { useEffect } from "react";
import { toast } from "react-toastify";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import { useForm } from "react-hook-form";
import { crearOEditarTipoParametro } from '../../services/tipos-parametros-service';

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const FormTiposParametros = ({ modalState, onSaved }) => {
    const { tipoParametro } = modalState.data;

    const defaultValues = {
        id: tipoParametro.id || "",
        nombre: tipoParametro.nombre || "",
        codigo: tipoParametro.codigo || "",
        descripcion: tipoParametro.descripcion || "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [tipoParametro]);

    const onCreatetipoParametro = async (tipoParametro) => {
        const resp = await crearOEditarTipoParametro({
            ...tipoParametro,
        });
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSaved();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formTipoParametro"
            onSubmit={onCreatetipoParametro}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    type="hidden"
                    name="id"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <InputController
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        name="nombre"
                        rules={REQUIRED_RULE}
                        placeholder="Nombre tipo parametro"
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        label="Codigo"
                        errors={form.formState.errors}
                        control={form.control}
                        name="codigo"
                        rules={REQUIRED_RULE}
                        placeholder="Codigo"
                        readOnly={tipoParametro.id != null}
                    />
                </Col>
                <Col sm={12}>
                    <InputController
                        type="textarea"
                        label="Descripcion"
                        errors={form.formState.errors}
                        control={form.control}
                        name="descripcion"
                        rules={REQUIRED_RULE}
                        placeholder="Descripcion"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormTiposParametros.propTypes = {
    modalState: PropTypes.object,
    onSaved: PropTypes.func
}

export default FormTiposParametros;
